import { FilterArrayType } from 'common/components/Filters';
import { OrderDirection, SortOrder } from 'common/utils/commonTypes';
import { PayCyclesOrderBy } from 'common/types/globalTypes';

type OrderLookup = {
  [direction in OrderDirection]: PayCyclesOrderBy[];
};

const orderByMap = new Map<string, OrderLookup>([
  [
    'description',
    {
      [OrderDirection.ASC]: ['DESCRIPTION_ASC'],
      [OrderDirection.DESC]: ['DESCRIPTION_DESC'],
    },
  ],
  [
    '_paymentType',
    {
      [OrderDirection.ASC]: [
        'PAYMENT_TRANSACTION_TYPE_BY_TRANSACTION_TYPE_ID__TRANSACTION_TYPE_ASC',
      ],
      [OrderDirection.DESC]: [
        'PAYMENT_TRANSACTION_TYPE_BY_TRANSACTION_TYPE_ID__TRANSACTION_TYPE_DESC',
      ],
    },
  ],
  [
    '_paymentAccount',
    {
      [OrderDirection.ASC]: [
        'PAYMENT_ACCOUNT_BY_PAYMENT_ACCOUNT_ID__BANK_ACCOUNT_NUMBER_ASC',
      ],
      [OrderDirection.DESC]: [
        'PAYMENT_ACCOUNT_BY_PAYMENT_ACCOUNT_ID__BANK_ACCOUNT_NUMBER_DESC',
      ],
    },
  ],
  [
    'defaultPaymentDate',
    {
      [OrderDirection.ASC]: ['DEFAULT_PAYMENT_DATE_ASC'],
      [OrderDirection.DESC]: ['DEFAULT_PAYMENT_DATE_DESC'],
    },
  ],
  [
    'currencyIsoCode',
    {
      [OrderDirection.ASC]: ['CURRENCY_ID_ASC'],
      [OrderDirection.DESC]: ['CURRENCY_ID_DESC'],
    },
  ],
  [
    'controlTotalAmount',
    {
      [OrderDirection.ASC]: ['CONTROL_TOTAL_AMOUNT_ASC'],
      [OrderDirection.DESC]: ['CONTROL_TOTAL_AMOUNT_DESC'],
    },
  ],
  [
    '_totalPayments',
    {
      [OrderDirection.ASC]: ['_TOTAL_PAYMENTS_ASC'],
      [OrderDirection.DESC]: ['_TOTAL_PAYMENTS_DESC'],
    },
  ],
  [
    '_paymentCount',
    {
      [OrderDirection.ASC]: ['_PAYMENT_COUNT_ASC'],
      [OrderDirection.DESC]: ['_PAYMENT_COUNT_DESC'],
    },
  ],
  [
    '_accountingStampTransactionReference',
    {
      [OrderDirection.ASC]: ['_ACCOUNTING_STAMP_TRANSACTION_REFERENCE_ASC'],
      [OrderDirection.DESC]: ['_ACCOUNTING_STAMP_TRANSACTION_REFERENCE_DESC'],
    },
  ],
  [
    '_accountingStampDate',
    {
      [OrderDirection.ASC]: ['_ACCOUNTING_STAMP_DATE_ASC'],
      [OrderDirection.DESC]: ['_ACCOUNTING_STAMP_DATE_DESC'],
    },
  ],
  [
    '_accountingStampUserName',
    {
      [OrderDirection.ASC]: ['_ACCOUNTING_STAMP_USER_NAME_ASC'],
      [OrderDirection.DESC]: ['_ACCOUNTING_STAMP_USER_NAME_DESC'],
    },
  ],
  [
    'status',
    {
      [OrderDirection.ASC]: ['STATUS_TYPE_BY_STATUS_TYPE_ID__STATUS_TYPE_ASC'],
      [OrderDirection.DESC]: [
        'STATUS_TYPE_BY_STATUS_TYPE_ID__STATUS_TYPE_DESC',
      ],
    },
  ],
]);

export const toOrderByVariable = (sort?: SortOrder) => {
  const orderByArray: PayCyclesOrderBy = 'PRIMARY_KEY_ASC';
  if (!sort) return [orderByArray];
  const orderBy = orderByMap.get(sort.column)?.[sort.direction];
  return [...(orderBy ? orderBy : []), orderByArray];
};

export const toPayCycleAccFilterVariable = (filterList: FilterArrayType[]) =>
  filterList.map((filter) => {
    switch (filter.filterKey) {
      case 'transactionTypeId':
      case 'paymentAccountId':
      case '_statusTypeId':
        return {
          [filter.filterKey]: {
            equalTo: filter.value,
          },
        };
      default:
        return undefined;
    }
  });
